//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { proposalCallWriteBack_fun, proposalCallBack_fun, policyfromcheck_fun } from '@/api/policymanagement';
export default {
  name: "submit-success",
  data: function data() {
    return {
      //1.申请电子保单同步方法是否返回结果 0没有返回过 1 返回过
      doPolicy1: 0,
      //2.申请电子保单轮询方法是否返回结果 0没有返回过 1 返回过
      doPolicy2: 0,
      //3.计时---毫秒数
      doPolicyCount: 0,
      //4.定时器
      applicationNo: "",
      nuclearfailure: "",
      since: false,
      cigreen: true,
      cigary: false
    };
  },
  created: function created() {
    console.log("页面submit-success");
    this.init_get();
  },
  methods: {
    // 获取自核是否成功
    init_get: function init_get() {
      var _this = this;

      this.applicationNo = this.$route.params.proposalNo;
      var reqdata = {
        proposalNo: this.$route.params.proposalNo
      };
      policyfromcheck_fun(reqdata).then(function (res) {
        if (res.isUndwrt == "1") {
          // this.$message({
          // 	message: '自核成功',
          // 	type: 'success'
          // });
          _this.cigreen = true;
          _this.cigary = false;
        } else if (res.isUndwrt == "0") {
          // this.$message({
          // 	message: '自核失败',
          // 	type: 'warning'
          // });
          _this.nuclearfailure = res.isUndwrtMessage;
          _this.since = true;
          _this.cigreen = false;
          _this.cigary = true;
        }
      });
    },
    // 这是一个定时器
    doPolicyTimer: function doPolicyTimer() {
      var _this2 = this;

      var doPolicyTimerId = setInterval(function () {
        var timeCount = Date.now();
        console.log("轮询" + timeCount);

        if (timeCount - _this2.doPolicyCount > 120000) {
          console.log("轮询结束--------2分钟超时关闭");
          clearInterval(doPolicyTimerId);

          _this2.$message({
            message: '数据正在推送核心，请稍等片刻再查询投保单状态，投保单状态变更前请不要进行重复操作',
            type: 'success'
          });

          _this2.$store.dispatch('delVisitedViews', _this2.$route);

          _this2.$router.go(-2);
        } else {
          console.log("判断是否轮询");

          if (_this2.doPolicy1 == 0 && _this2.doPolicy2 == 0) {
            console.log("每隔5秒-------------------轮询接口调用开始");
            var data = {
              reqProposalCallDtoList: [{
                proposalNo: _this2.$route.params.proposalNo,
                type: 1
              }]
            };
            proposalCallBack_fun(data).then(function (res) {
              if (res.rtnCode == '0000') {
                _this2.$message({
                  message: '申请电子保单，提交成功，请在投保单/保单查询菜单执行后续操作',
                  type: 'success'
                });

                _this2.doPolicy2 = 1;

                _this2.$store.dispatch('delVisitedViews', _this2.$route);

                _this2.$router.go(-2);
              } else if (res.rtnCode == '9999') {
                console.log("没有结果继续轮询");
              }
            });
          } else {
            console.log("判断不轮询-----------轮询结束--------状态变化关闭");
            clearInterval(doPolicyTimerId);
          }
        }
      }, 5000);
    },
    //-------------------------    1-申请电子保单，2-申请CI凭证，3-申报
    get_data: function get_data(type) {
      var _this3 = this;

      var data = {
        reqProposalCallDtoList: [{
          proposalNo: this.$route.params.proposalNo,
          protocolNo: this.$route.params.protocolNo,
          type: type
        }]
      };

      if (type == "1") {
        proposalCallWriteBack_fun(data).then(function (res) {
          console.log("申请电子保单结果开始" + _this3.doPolicy2);

          if (_this3.doPolicy2 == 0) {
            if (res.rtnCode == "0000") {
              _this3.$message({
                message: '申请电子保单，提交成功，请在投保单/保单查询菜单执行后续操作',
                type: 'success'
              });
            } else if (res.rtnCode == "9999") {
              _this3.$message({
                message: '申请电子保单，提交失败',
                type: 'warning'
              });
            }

            console.log("------------------------");
            _this3.doPolicy1 = 1;
          }
        });
      } else if (type == "2") {
        proposalCallWriteBack_fun(data).then(function (res) {
          if (res.rtnCode == "0000") {// this.$message({
            // 	message: '提交成功',
            // 	type: 'success'
            // });
          } else if (res.rtnCode == "9999") {
            _this3.$message({
              message: '该记录不满足自核规则，需转小保单投保',
              type: 'warning'
            });
          }
        });
      } else if (type == "3") {
        proposalCallWriteBack_fun(data).then(function (res) {
          if (res.rtnCode == "0000") {
            _this3.$message({
              message: '申报确认，提交成功，请在投保单/保单查询菜单执行后续操作',
              type: 'success'
            });
          } else if (res.rtnCode == "9999") {
            _this3.$message({
              message: '申报确认，提交失败',
              type: 'warning'
            });
          }
        });
      }
    },
    //申请电子保单
    ask_policy: function ask_policy() {
      this.doPolicy1 = 0;
      this.doPolicy2 = 0;
      this.doPolicyCount = Date.now();
      setTimeout(this.doPolicyTimer(), 20000);
      this.get_data(1); // this.$router.push({
      // 	path: `/policymanagement/policysearch`
      // });

      this.$store.dispatch('delVisitedViews', this.$route);
      this.$router.go(-2);
    },
    //申请电子凭证
    ask_policy_assess: function ask_policy_assess() {
      this.get_data(2);
      this.$store.dispatch('delVisitedViews', this.$route);
      this.$router.go(-2);
    },
    //申报确认
    ask_policy_confirm: function ask_policy_confirm() {
      this.get_data(3);
      this.$store.dispatch('delVisitedViews', this.$route);
      this.$router.go(-2);
    }
  }
};